import classNames from "classnames";
import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import React, { useRef } from "react";

import useKeyboard from "@repo/shopifyV2/hooks/useKeyboard";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";

import { useLayoutStore } from "@store/layout";

export default function Toast() {
  const { toast, closeToast } = useLayoutStore();

  const ref = useRef(null);
  useKeyboard(ref);

  return (
    // 채널톡 위젯이 z-index 10000000 을 쓰기 때문에 토스트만 레이어 규칙(z-70)의 예외로 그 위에 올린다
    <div className="pointer-events-none fixed inset-0 z-10000001" ref={ref}>
      <div className="pc:right-5 pc:top-14 pc:w-auto absolute bottom-4 left-4 flex w-[calc(100%-2rem)] flex-col items-end gap-2.5">
        <LayoutGroup>
          <AnimatePresence>
            {toast.map((item) => (
              <motion.div
                animate={{ x: 0 }}
                className={classNames(
                  item.id === "-1" && "hidden",
                  "pc:w-auto pc:gap-5 pointer-events-auto flex h-fit w-full items-center justify-between gap-4 overflow-hidden bg-neutral-800/95 p-5 text-white opacity-95 shadow dark:shadow-white",
                )}
                exit={{ opacity: 0 }}
                initial={{ x: "100%" }}
                key={item.id}
                layout="position"
                transition={{ ease: [0.1, 0, 0.05, 1], duration: 0.2 }}
              >
                <p className="pc:whitespace-pre">{item?.message || ""}</p>
                <Button
                  as="wrapper"
                  className="text-white"
                  onClick={() => {
                    const findIndex = toast.findIndex((data) => data.id === item.id);
                    closeToast([...toast.slice(0, findIndex), ...toast.slice(findIndex + 1)]);
                  }}
                >
                  <Icon className="size-2.5" name="Close" />
                </Button>
              </motion.div>
            ))}
          </AnimatePresence>
        </LayoutGroup>
      </div>
    </div>
  );
}
